import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import pluginImage from '../../assets/images/GHL-Plugin.png';
import globalImage from '../../assets/images/Global-Coverage.png';
import featuresImage from '../../assets/images/Top-features.png';

const SwiperNavStyle = createGlobalStyle`
  .swiper-button-next,
  .swiper-button-prev {
    color: #FF4D00 !important;
    stroke: #FF4D00 !important;
    width: clamp(32px, 6vw, 48px) !important;
    height: clamp(32px, 6vw, 48px) !important;
  }
  .swiper-button-next:after,
  .swiper-button-prev:after {
    color: #FF4D00 !important;
    font-size: clamp(24px, 4vw, 36px) !important;
  }
  .swiper-pagination {
    position: absolute !important;
    left: 50% !important;
    bottom: 40px !important;
    transform: translateX(-50%) !important;
    z-index: 20;
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto !important;
    gap: 8px;
    padding: 6px 12px;
  }
  .swiper-pagination-bullet {
    background: #FF4D00 !important;
    opacity: 0.3;
    width: 10px;
    height: 10px;
    margin: 0 !important;
    transition: all 0.2s ease;
  }
  .swiper-pagination-bullet-active {
    background: #FF4D00 !important;
    opacity: 1;
    width: 14px;
    height: 14px;
  }
  @media (max-width: 768px) {
    .swiper-pagination {
      bottom: 30px !important;
      padding: 4px 10px;
    }
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
    }
    .swiper-pagination-bullet-active {
      width: 12px;
      height: 12px;
    }
  }
  @media (max-width: 480px) {
    .swiper-pagination {
      bottom: 20px !important;
      padding: 3px 8px;
      gap: 6px;
    }
    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
    }
    .swiper-pagination-bullet-active {
      width: 10px;
      height: 10px;
    }
  }
`;

const HeroSection = styled.section`
  width: 100%;
  height: 100vh;
  max-height: 600px;
  background: var(--light-color);
  position: relative;
  margin: 0;
  padding: 0;
  overflow: hidden;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 1024px) {
    max-height: 450px;
  }

  @media (max-width: 768px) {
    max-height: 350px;
  }

  @media (max-width: 480px) {
    max-height: 220px;
  }
`;

const SlideImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--light-color);
  /* Maintain aspect ratio for images */
  aspect-ratio: 16/7;
  @media (max-width: 768px) {
    aspect-ratio: 16/9;
  }
  @media (max-width: 480px) {
    aspect-ratio: 16/12;
  };
  background-color: red;
`;

const SlideImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  background: #fff;
`;

const slides = [
  {
    image: pluginImage,
  },
  {
    image: globalImage,
  },
  {
    image: featuresImage,
  },
];

const Hero: React.FC = () => {
  return (
    <HeroSection id="hero">
      <SwiperNavStyle />
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        effect="fade"
        loop
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <SlideImageWrapper>
              <SlideImg src={slide.image} alt={`slide-${index}`} />
            </SlideImageWrapper>
          </SwiperSlide>
        ))}
      </Swiper>
    </HeroSection>
  );
};

export default Hero;